'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplateService = void 0;
const tenant_settings_model_1 = require("../../models/tenant-settings.model");
const store_manager_1 = require("../../managers/store.manager");
const cms_interface_1 = require("../../cms.interface");
class EmailTemplateService {
    constructor(config) {
        var _a;
        this.config = config;
        this.tenantConfig = new tenant_settings_model_1.TenantConfig((_a = this.config) === null || _a === void 0 ? void 0 : _a.settings);
    }
    /**
     * Get email template by tag
     * @param templateId Template ID
     */
    async getEmailTemplate(templateId) {
        try {
            const store = new store_manager_1.StoreManager(this.tenantConfig, cms_interface_1.MODULE.EMAIL_TEMPLATES, templateId);
            return await store.get();
        }
        catch (_) {
            // front-end and backend supported logging
            return null;
        }
    }
}
exports.EmailTemplateService = EmailTemplateService;
//# sourceMappingURL=email-template.service.js.map